export default {
  LOGIN_SUCCESS(state, authToken) {
    const newState = state;

    newState.authToken = authToken;
    newState.isAuthenticated = true;
  },
  LOGOUT(state) {
    const newState = state;

    newState.authToken = null;
    newState.isAuthenticated = false;
  },
};
